import { render, staticRenderFns } from "./video-embed.vue?vue&type=template&id=751c1118"
import script from "./video-embed.vue?vue&type=script&lang=js"
export * from "./video-embed.vue?vue&type=script&lang=js"
import style0 from "./video-embed.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports